import { Backdrop, CircularProgress, Grid, Typography } from '@mui/material';
import { useAppSelector } from '../../redux_store/reduxStore';
import { loaderState } from '../../redux_store/slices/loaderSlice';

export interface BakeasyLoaderReduxProp {
  isLoading?: boolean;
  message: string;
}

function BakeasyLoaderRedux() {
  const { message, isLoading } = useAppSelector(loaderState);

  return (
    <Backdrop
      sx={{ color: 'white', zIndex: theme => theme.zIndex.modal + 1 }}
      open={isLoading ?? false}
    >
      <Grid sx={{ backgroundColor: '#D7DBDD', padding: 2 }}>
        <Grid
          container
          direction={'column'}
          alignItems={'center'}
          rowGap={1}
          justifyContent={'center'}
        >
          <CircularProgress color="primary" />
          <Typography color="primary" fontWeight={600} marginTop={1} fontSize={18}>
            {message ?? 'Please wait...'}
          </Typography>
        </Grid>
      </Grid>
    </Backdrop>
  );
}

export default BakeasyLoaderRedux;
